import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    placeholder: String,
    allowEmpty: { type: Boolean, default: true }
  }

  connect() {
    this.tomSelect = new TomSelect(this.element, {
      create: false,
      sortField: { field: "text", direction: "asc" },
      placeholder: this.placeholderValue || "Zoeken...",
      allowEmptyOption: this.allowEmptyValue,
      render: {
        no_results: () => '<div class="no-results">Geen resultaten gevonden</div>'
      }
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
